import { defineMessages } from "react-intl";

export default defineMessages({
  ajalla: {
    id: "rajoitteet.ajalla",
    defaultMessage: "ajalla"
  },
  muokkaaRajoitetta: {
    id: "rajoitteet.muokkaaRajoitetta",
    defaultMessage: "Muokkaa"
  },
  poistaRajoite: {
    id: "rajoitteet.poistaRajoite",
    defaultMessage: "Poista"
  },
  rajoite: {
    id: "rajoitteet.rajoite",
    defaultMessage: "Rajoite"
  },
  rajoitteet: {
    id: "rajoitteet.rajoitteet",
    defaultMessage: "Rajoitteet"
  },
  lisaaAlirajoite: {
    id: "rajoitteet.lisaaAlirajoite",
    defaultMessage: "Lisää alirajoite"
  },
  lisaaKohdennus: {
    id: "rajoitteet.lisaaKohdennus",
    defaultMessage: "Lisää kohdennus"
  },
  lisaaRajoite: {
    id: "rajoitteet.lisaaRajoite",
    defaultMessage: "Lisää rajoite"
  },
  rajoitekriteerit: {
    id: "rajoitteet.rajoitekriteerit",
    defaultMessage: "Rajoitekriteerit"
  },
  lisaaKriteeri: {
    id: "rajoitteet.lisaaKriteeri",
    defaultMessage: "Lisää kriteeri"
  },
  kohdennus: {
    id: "rajoitteet.kohdennus",
    defaultMessage: "Kohdennus"
  },
  rajoituksenKohde: {
    id: "rajoitteet.rajoituksenKohde",
    defaultMessage: "Rajoituksen kohde"
  },
  eiRajoitteita: {
    id: "rajoitteet.eiRajoitteita",
    defaultMessage: "Ei rajoitteita"
  }
});
